import React, { useEffect } from "react";
import {
  Row,
  Container,
  Col,
  Form,
  Button,
  Stack,
  Alert,
} from "react-bootstrap";
import "./App.css";
import { Link } from "react-router-dom";

const First = () => {
  useEffect(() => {
    window.document.title = "提货须知";
  }, []);

  return (
    <Container className="p-3 bg">
      <div>
        <p className="title">苏浔蟹礼大闸蟹提货告知书</p>
        <p>尊敬的客户：您好，感谢您对苏浔蟹礼的支持与信任。</p>
        <p>2026年度大闸蟹提货开始了！</p>
        <br />
        <br />
        <p>如有疑问可咨询我司客服电话4001608088 (09:00-18:00)</p>
      </div>
      <div className="w-100 d-flex justify-content-center">
        <Button className="w-100" href="#second" variant="primary">
          我已知晓，开始提货
        </Button>
      </div>
    </Container>
  );
};

export default First;
